import React from "react";
import "./Footer.css";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import tiktok from "../assets/img/tiktok.png";

export default function Footer() {
  return (
    <>
      <div className="hr-line">
        <div></div>
      </div>

      <footer>
        <div className="container">
          <div className="left-footer">
            <div className="links">
              <p>Home </p>
              <p>Why Wellingtonia International School</p>
              <a
                href="https://forms.gle/4nX6qFjLCGiYWK5h7"
                target="_blank"
                rel="noreferrer"
              >
                Join Wellingtonia
              </a>
            </div>
          </div>
          <div className="right-footer">
            {/* <div className="footer-icon">
              <a
                href={"https://www.instagram.com/vibesandvent/"}
                target={"_blank"}
                rel="noreferrer"
              >
              </a>
            </div> */}
            <div className="footer-icon">
              <a
                href={"https://www.instagram.com/vibesandvent/"}
                target={"_blank"}
                rel="noreferrer"
              ></a>
            </div>
            <div className="footer-icon">
              {/* <a
                href={"https://www.instagram.com/vibesandvent/"}
                target={"_blank"}
                rel="noreferrer"
              >
              </a> */}
            </div>
            <div className="footer-icon">
              <img src={tiktok} style={{ width: 20 }} alt="tiktok" />
            </div>
          </div>
        </div>
        <div className="copyright" style={{ fontSize: 12 }}>
          © 2024 Wellingtonia International School. All right Reserved
        </div>
      </footer>
    </>
  );
}
